import React from 'react';
import { useDispatch } from 'react-redux';
import { CardButton, Overlay, OverlayInner } from '../EditorOverlay/styles';
import { getGalllleryUrl, getRepRoute } from '../../../../../actions/getGalllleryUrl';
import { CardButtonWrapper, CardOverlayInner, CardOverlayWrapper, CardText } from './styles';
import { FlexBox, HintTooltip, useIsMobile, useToasts } from '@brg/ui';
import { AgreeCardIcon, CardIcon } from '../EditorOverlayNew/CardIcon';
import useLocalization from '../../../../../hooks/useLocalization';
import { useGetActualLocalStorageValue } from '../../../../../hooks/useGetActualLocalStorageValue';
import { CopyIcon } from '../EditorOverlayNew/CopyIcon';
var CardOverlay = function (_a) {
    var cardId = _a.cardId, cardIds = _a.cardIds, isShop = _a.isShop, postId = _a.postId, additionalInfo = _a.additionalInfo, style = _a.style, userId = _a.userId, context = _a.context, reduceLayer = _a.reduceLayer, cardProviderId = _a.cardProviderId;
    var t = useLocalization().t;
    var handleCardClick = function () {
        var url = "".concat(getRepRoute(cardProviderId), "/card/").concat(cardId);
        window.open(url, '_blank');
    };
    var toasts = useToasts();
    var isMobile = useIsMobile();
    var handleCopyClick = function () {
        var link = "".concat(window.location.origin).concat(window.location.pathname, "#").concat(postId);
        var formattedLink = link.replace('edit', 'project');
        navigator.clipboard
            .writeText(formattedLink)
            .then(function () { return toasts.info(t('lms.podcast.link_copied')); });
    };
    var isCardBlock = Boolean(['products', 'card'].includes(style) || cardId);
    var localStorageCopyLinkMode = useGetActualLocalStorageValue('copyLinkMode');
    if ((!((cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) > 0 || (cardId && isCardBlock)) || style === 'products') && localStorageCopyLinkMode !== 'true')
        return null;
    return (React.createElement(CardOverlayWrapper, { reduceLayer: reduceLayer, isHoveredOverlay: !isCardBlock },
        React.createElement(CardOverlayInner, null,
            React.createElement("div", null),
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', align: 'flex-end', id: "edit-".concat(postId), style: { rowGap: '10px' } },
                !isMobile && localStorageCopyLinkMode === 'true' && (React.createElement(HintTooltip, { h: '40px', w: '48px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('hint.copy'), noDisappearDelay: true },
                    React.createElement(CopyIcon, { onClick: handleCopyClick }))),
                !isCardBlock && (cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) > 0 && (React.createElement(CardIcon, { text: "\u0421\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 | ".concat(cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) })),
                isCardBlock && cardId && (React.createElement(CardIcon, { onClick: handleCardClick, text: t('edit_buttons.open_card') }))))));
};
export default CardOverlay;
//# sourceMappingURL=CardOverlay.js.mapimport React from 'react';
import { useDispatch } from 'react-redux';
import { CardButton, Overlay, OverlayInner } from '../EditorOverlay/styles';
import { getGalllleryUrl, getRepRoute } from '../../../../../actions/getGalllleryUrl';
import { CardButtonWrapper, CardOverlayInner, CardOverlayWrapper, CardText } from './styles';
import { FlexBox, HintTooltip, useIsMobile, useToasts } from '@brg/ui';
import { AgreeCardIcon, CardIcon } from '../EditorOverlayNew/CardIcon';
import useLocalization from '../../../../../hooks/useLocalization';
import { useGetActualLocalStorageValue } from '../../../../../hooks/useGetActualLocalStorageValue';
import { CopyIcon } from '../EditorOverlayNew/CopyIcon';
var CardOverlay = function (_a) {
    var cardId = _a.cardId, cardIds = _a.cardIds, isShop = _a.isShop, postId = _a.postId, additionalInfo = _a.additionalInfo, style = _a.style, userId = _a.userId, context = _a.context, reduceLayer = _a.reduceLayer, cardProviderId = _a.cardProviderId;
    var t = useLocalization().t;
    var handleCardClick = function () {
        var url = "".concat(getRepRoute(cardProviderId), "/card/").concat(cardId);
        window.open(url, '_blank');
    };
    var toasts = useToasts();
    var isMobile = useIsMobile();
    var handleCopyClick = function () {
        var link = "".concat(window.location.origin).concat(window.location.pathname, "#").concat(postId);
        var formattedLink = link.replace('edit', 'project');
        navigator.clipboard
            .writeText(formattedLink)
            .then(function () { return toasts.info(t('lms.podcast.link_copied')); });
    };
    var isCardBlock = Boolean(['products', 'card'].includes(style) || cardId);
    var localStorageCopyLinkMode = useGetActualLocalStorageValue('copyLinkMode');
    if ((!((cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) > 0 || (cardId && isCardBlock)) || style === 'products') && localStorageCopyLinkMode !== 'true')
        return null;
    return (React.createElement(CardOverlayWrapper, { reduceLayer: reduceLayer, isHoveredOverlay: !isCardBlock },
        React.createElement(CardOverlayInner, null,
            React.createElement("div", null),
            React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', align: 'flex-end', id: "edit-".concat(postId), style: { rowGap: '10px' } },
                !isMobile && localStorageCopyLinkMode === 'true' && (React.createElement(HintTooltip, { h: '40px', w: '48px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('hint.copy'), noDisappearDelay: true },
                    React.createElement(CopyIcon, { onClick: handleCopyClick }))),
                !isCardBlock && (cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) > 0 && (React.createElement(CardIcon, { text: "\u0421\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 | ".concat(cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) })),
                isCardBlock && cardId && (React.createElement(CardIcon, { onClick: handleCardClick, text: t('edit_buttons.open_card') }))))));
};
export default CardOverlay;
//# sourceMappingURL=CardOverlay.js.map